import {Component} from "@angular/core";

@Component({
    template: `
        <div class="loading">
            <img
                    class="loading-spinner"
                    src="assets/img/spinner-green-big.png"
                    alt="spinner"
            />
        </div>
    `,
    styles: [`
      :host {
        display: block;
      }
      .loading-spinner {
        animation: rotate 1s linear infinite;
      }
      @keyframes rotate {
        0% { transform: rotate(0deg);}
        100% { transform: rotate(360deg); }
      }
    `]

})
export class LoadingPopupComponent {

}
